const updateBessTransition = (CBAssetList,defaultValues,projectTypeValue, bess, defaults) => {
const derList = [...CBAssetList];
const updatedBess = {...bess};
const defaultBessData = {};
 if(bess?.assetAttributes){
  for (let defaultData of bess?.assetAttributes) {
    defaultBessData[defaultData["type"]] = defaultData["value"];
  }
 }
if(defaultBessData?.isMultiBess === "true"){
     derList[2].configData.quantityOfBessList =JSON.parse(defaultBessData?.quantityOfBess);
     derList[2].configData.isMultiBess = true;
     derList[2].configData.quantityOfBess = 1;
}else{
    derList[2].configData.isMultiBess = false;
}
derList[2].assetDetails[0] = updatedBess;
derList[2].uiData.configured = false;
return derList;
}
 export  {updateBessTransition}
 